var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1923 3.18039L22.2173 2.12738L6.98828 16.0927V18.5747L7.96329 19.6277L23.1923 3.18039Z",
    fill: "#8CA82F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5872 0.372284L7.95827 14.0116L2.94377 8.59597L0.34375 11.404L6.98326 18.5747L22.2123 2.12735L20.5872 0.372284Z",
    fill: "#A5C244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.432 2.91714L20.8319 0.109059C20.7673 0.0392651 20.6796 0 20.5882 0C20.4968 0 20.4091 0.0392154 20.3445 0.109059L7.95923 13.4851L3.18852 8.33275C3.12385 8.26295 3.0362 8.22369 2.94478 8.22369C2.85336 8.22369 2.76566 8.2629 2.70104 8.33275L0.100969 11.1408C-0.0336563 11.2862 -0.0336563 11.5219 0.100969 11.6673L7.71549 19.8909C7.78278 19.9637 7.87103 20 7.95923 20C8.04743 20 8.13568 19.9637 8.20297 19.8909L23.432 3.44362C23.5666 3.29822 23.5666 3.06253 23.432 2.91714ZM7.95923 19.1012L0.832237 11.4041L2.94478 9.12252L7.71549 14.2749C7.85012 14.4203 8.06839 14.4203 8.20297 14.2749L20.5882 0.898829L22.7007 3.18038L7.95923 19.1012Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessNotificationIcon);
export default __webpack_public_path__ + "static/media/success_notification_icon.74dbfa9b62e212f1143f9a5dda733fa4.svg";
export { ForwardRef as ReactComponent };